/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Pricing_Faq_7_AInputs */

const en_mk_pricing_faq_7_a = /** @type {(inputs: Mk_Pricing_Faq_7_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Payment is in rupiah, billed monthly, with no minimum term. For the Enterprise plan and special billing needs (POs, tax invoices), reach us through the About page.`)
};

const id_mk_pricing_faq_7_a = /** @type {(inputs: Mk_Pricing_Faq_7_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pembayaran dalam rupiah, ditagih bulanan, tanpa kontrak minimum. Untuk paket Enterprise dan kebutuhan penagihan khusus (PO, faktur pajak), hubungi kami lewat halaman Tentang.`)
};

/**
* | output |
* | --- |
* | "Payment is in rupiah, billed monthly, with no minimum term. For the Enterprise plan and special billing needs (POs, tax invoices), reach us through the About..." |
*
* @param {Mk_Pricing_Faq_7_AInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_pricing_faq_7_a = /** @type {((inputs?: Mk_Pricing_Faq_7_AInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Pricing_Faq_7_AInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_pricing_faq_7_a(inputs)
	return en_mk_pricing_faq_7_a(inputs)
});